import NewFund from './NewFund';

export default NewFund;
